import { extendTheme } from '@chakra-ui/react'
import { colors } from '.'

export const theme = extendTheme({
  colors: {
    ...colors,
  },
})
